import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your message. We will get back to you shortly!');
    setFormData({
      name: '',
      email: '',
      phone: '',
      eventType: '',
      message: ''
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen w-full bg-h2o-950 text-slate-100 flex flex-col pt-20" data-id="element-258">
      {/* Hero Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-259">
        <div className="absolute inset-0 z-0" data-id="element-260">
          <img src="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=1920&q=80" alt="Contact Us" className="w-full h-full object-cover object-center" data-id="element-261" />
          <div className="absolute inset-0 bg-h2o-950/80" data-id="element-262" />
        </div>
        <div className="relative z-10 text-center px-6" data-id="element-263">
          <motion.h1 initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.2
        }} className="text-4xl md:text-6xl font-bold text-white mb-4" data-id="element-264">
            Get In Touch
          </motion.h1>
          <motion.p initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-265">
            We'd love to hear from you. Let's start planning your next
            extraordinary event.
          </motion.p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto w-full" data-id="element-266">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-267">
          {/* Form Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4
        }} className="bg-h2o-900 border border-slate-700/50 rounded-lg p-8 md:p-10 shadow-xl" data-id="element-268">
            <h2 className="text-2xl font-bold text-white mb-6" data-id="element-269">
              Send us a Message
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-270">
              <div data-id="element-271">
                <label htmlFor="name" className="block text-slate-300 text-sm font-medium mb-2" data-id="element-272">
                  Full Name
                </label>
                <input type="text" id="name" required value={formData.name} onChange={handleChange} className="w-full bg-h2o-950 border border-slate-600 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:border-h2o-cyan focus:ring-1 focus:ring-h2o-cyan outline-none transition-shadow" placeholder="Jane Doe" data-id="element-273" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-274">
                <div data-id="element-275">
                  <label htmlFor="email" className="block text-slate-300 text-sm font-medium mb-2" data-id="element-276">
                    Email Address
                  </label>
                  <input type="email" id="email" required value={formData.email} onChange={handleChange} className="w-full bg-h2o-950 border border-slate-600 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:border-h2o-cyan focus:ring-1 focus:ring-h2o-cyan outline-none transition-shadow" placeholder="jane@example.com" data-id="element-277" />
                </div>
                <div data-id="element-278">
                  <label htmlFor="phone" className="block text-slate-300 text-sm font-medium mb-2" data-id="element-279">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" required value={formData.phone} onChange={handleChange} className="w-full bg-h2o-950 border border-slate-600 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:border-h2o-cyan focus:ring-1 focus:ring-h2o-cyan outline-none transition-shadow" placeholder="(555) 123-4567" data-id="element-280" />
                </div>
              </div>
              <div data-id="element-281">
                <label htmlFor="eventType" className="block text-slate-300 text-sm font-medium mb-2" data-id="element-282">
                  Event Type
                </label>
                <select id="eventType" required value={formData.eventType} onChange={handleChange} className="w-full bg-h2o-950 border border-slate-600 rounded-lg px-4 py-3 text-white focus:border-h2o-cyan focus:ring-1 focus:ring-h2o-cyan outline-none transition-shadow appearance-none" data-id="element-283">
                  <option value="" disabled data-id="element-284">
                    Select an event type
                  </option>
                  <option value="wedding" data-id="element-285">Wedding</option>
                  <option value="birthday" data-id="element-286">Birthday</option>
                  <option value="corporate" data-id="element-287">Corporate</option>
                  <option value="private" data-id="element-288">Private Party</option>
                  <option value="other" data-id="element-289">Other</option>
                </select>
              </div>
              <div data-id="element-290">
                <label htmlFor="message" className="block text-slate-300 text-sm font-medium mb-2" data-id="element-291">
                  Your Message
                </label>
                <textarea id="message" required rows={5} value={formData.message} onChange={handleChange} className="w-full bg-h2o-950 border border-slate-600 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:border-h2o-cyan focus:ring-1 focus:ring-h2o-cyan outline-none transition-shadow resize-none" placeholder="Tell us about your event..." data-id="element-292" />
              </div>
              <button type="submit" className="w-full bg-h2o-cyan text-h2o-950 font-bold px-8 py-4 rounded-lg hover:bg-h2o-cyan-light transition-colors focus-visible-ring" data-id="element-293">
                Send Message
              </button>
            </form>
          </motion.div>

          {/* Info Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.5
        }} className="flex flex-col justify-between" data-id="element-294">
            <div data-id="element-295">
              <h2 className="text-2xl font-bold text-white mb-8" data-id="element-296">
                Contact Information
              </h2>
              <ul className="space-y-8" data-id="element-297">
                <li className="flex items-start" data-id="element-298">
                  <div className="w-12 h-12 rounded-full bg-h2o-900 flex items-center justify-center mr-4 shrink-0 border border-slate-700" data-id="element-299">
                    <MapPin className="w-6 h-6 text-h2o-cyan" data-id="element-300" />
                  </div>
                  <div data-id="element-301">
                    <h4 className="text-white font-semibold mb-1" data-id="element-302">Address</h4>
                    <p className="text-slate-400" data-id="element-303">
                      5005 Jackson Street
                      <br data-id="element-304" />
                      Hyattsville, MD 20706
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-305">
                  <div className="w-12 h-12 rounded-full bg-h2o-900 flex items-center justify-center mr-4 shrink-0 border border-slate-700" data-id="element-306">
                    <Phone className="w-6 h-6 text-h2o-cyan" data-id="element-307" />
                  </div>
                  <div data-id="element-308">
                    <h4 className="text-white font-semibold mb-1" data-id="element-309">Phone</h4>
                    <p className="text-slate-400" data-id="element-310">(301) 555-H2O0</p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-311">
                  <div className="w-12 h-12 rounded-full bg-h2o-900 flex items-center justify-center mr-4 shrink-0 border border-slate-700" data-id="element-312">
                    <Mail className="w-6 h-6 text-h2o-cyan" data-id="element-313" />
                  </div>
                  <div data-id="element-314">
                    <h4 className="text-white font-semibold mb-1" data-id="element-315">Email</h4>
                    <a href="mailto:events@h2oeventcentre.com" className="text-slate-400 hover:text-h2o-cyan transition-colors" data-id="element-316">
                      events@h2oeventcentre.com
                    </a>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-317">
                  <div className="w-12 h-12 rounded-full bg-h2o-900 flex items-center justify-center mr-4 shrink-0 border border-slate-700" data-id="element-318">
                    <Clock className="w-6 h-6 text-h2o-cyan" data-id="element-319" />
                  </div>
                  <div data-id="element-320">
                    <h4 className="text-white font-semibold mb-1" data-id="element-321">Hours</h4>
                    <p className="text-slate-400" data-id="element-322">
                      Mon-Sat: 10AM - 8PM
                      <br data-id="element-323" />
                      Sun: By Appointment
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="mt-12 w-full h-64 rounded-lg overflow-hidden border border-slate-700/50 relative bg-h2o-900" data-id="element-324">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d49862.45!2d-77.02!3d38.78!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b0!2sNational+Harbor!5e0!3m2!1sen!2sus!4v1" width="100%" height="100%" style={{
              border: 0,
              filter: 'grayscale(1) invert(0.9) hue-rotate(180deg) contrast(1.2)'
            }} allowFullScreen={false} loading="lazy" title="H2O Event Centre Location" className="absolute inset-0" data-id="element-325"></iframe>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-326" />
    </motion.main>;
}